import React from "react"
import "./style.css"

const WhiteButton = ({ show = true, children, extraClass, ...props }) => {
  if (!show) {
    return <></>
  }

  return (
    <button className={`white-btn-wrapper ${extraClass}`} {...props} tabIndex="0">
      {children}
    </button>
  )
}

export { WhiteButton }
